export default function CsCyberCrime() {
  return (
    <h2>Cs Cyber Crime</h2>
  );
}
